import React, { useEffect, useState } from "react";
import Atto3 from "../../assets/img/atto3.png";
import { useSearchParams } from "react-router-dom";
import { Spinner } from "@nextui-org/spinner";
import Swal from "sweetalert2";
import { ReactComponent as Warning } from "../../assets/icons/warning.svg";
import { Check } from "lucide-react";
import warningIcon from "../../assets/icons/warning.svg";
import { VerifyOtp } from "../../services/AuthService";
import AppUserProfile from "../../assets/js/AppUserProfile";
// import AppConstant from "../../assets/js/AppConstant";

const ExternalLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const [searchParams] = useSearchParams();
  const oneTimeCode = searchParams.get("one_time_code");

  const handleValidateOtp = async () => {
    if (!oneTimeCode) {
      setError("OTP not found in URL");
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      const response = await VerifyOtp({ oneTimeCode });
      if (response.status === 200) {
        let data = response.data;
        AppUserProfile.setData(data.token);

        const userProfile = AppUserProfile.getData();

        if (!userProfile.whoami) {
          setError("User has no authorize role");
          Swal.fire({
            title: "Error!",
            text: "User has no authorize role",
            confirmButtonText: "OK",
            iconColor: "transparent",
            iconHtml: `<div class="w-52 h-52 bg-warning" style="width: 60px; height: 60px; mask: url('${warningIcon}') no-repeat center / contain; -webkit-mask: url('${warningIcon}') no-repeat center / contain;" />`,
          });
          AppUserProfile.clearData();
          return;
        }

        setSuccess(true);
        Swal.fire({
          title: "Success!",
          text: "OTP verified successfully.",
          icon: "success",
          showConfirmButton: false,
          timer: 1300,
        }).then(() => {
          window.location.href = "/";
        });
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Failed to verify OTP. Please try again."
      );
      Swal.fire({
        title: "Error!",
        text:
          error.response?.data?.message ||
          "Failed to verify OTP. Please try again.",
        confirmButtonText: "OK",
        iconColor: "transparent",
        iconHtml: `<div class="w-52 h-52 bg-warning" style="width: 60px; height: 60px; mask: url('${warningIcon}') no-repeat center / contain; -webkit-mask: url('${warningIcon}') no-repeat center / contain;" />`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    AppUserProfile.clearData();

    if (oneTimeCode) {
      handleValidateOtp();
    } else {
      setError("Unauthorized, please try again.");
      setIsLoading(false);
    }
  }, [oneTimeCode]);

  return (
    <>
      <div className="min-h-screen w-full bg-black">
        <div
          className="min-h-screen w-full bg-black relative bg-cover bg-center"
          style={{ backgroundImage: `url(${Atto3})` }}
        >
          <div className="flex h-full w-full items-center justify-center z-40">
            <div className="flex w-fit flex-col gap-4 rounded-large px-8 pb-4 pt-6 mt-20 mx-20 bg-black/80 text-white items-center">
              {isLoading && (
                <>
                  <Spinner size="lg" color="primary" />
                  <p className="text-xl font-semibold text-center">
                    Verifying your OTP...
                  </p>
                  <p className="text-lg text-gray-400 text-center text-nowrap">
                    Please wait while we validate your one-time code
                  </p>
                </>
              )}

              {!isLoading && error && (
                <>
                  <Warning className="text-warning w-14 h-14" />
                  <p className="text-xl font-semibold text-center text-red-500">
                    Verification Failed
                  </p>
                  <p className="text-lg text-white text-center">{error}</p>
                  {/* <a
                    href={AppConstant.RMOS_URL}
                    className="text-blue-400 underline"
                  >
                    {AppConstant.RMOS_URL}
                  </a> */}
                </>
              )}

              {!isLoading && success && (
                <>
                  <Check className="text-success w-14 h-14" />
                  <p className="text-xl font-semibold text-center text-green-400">
                    OTP Verified Successfully!
                  </p>
                  <p className="text-lg text-gray-400 text-center">
                    Redirecting you to the ticket page...
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExternalLogin;
